module.exports = __webpack_public_path__ + "static/prize-img-6069e84d7cd5ff4024df374e87743b5d.jpg";